import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { FCWithChildren } from 'common/types';
import SunshineModal from 'components/_core/SunshineModal';

import {
  FiscalIdFormSchema,
  fiscalIdValidationSchema,
} from '../../form/fiscalIdForm.schema';
import Body from './components/Body';
import Footer from './components/Footer';

interface FiscalIdModalParts {
  Body: typeof Body;
  Footer: typeof Footer;
}

type FiscalIdModalProps = {
  onClose: () => void;
};

const FiscalIdModal: FCWithChildren<FiscalIdModalProps> &
  FiscalIdModalParts = ({ children, onClose }) => {
  const methods = useForm<FiscalIdFormSchema>({
    mode: 'onChange',
    resolver: zodResolver(fiscalIdValidationSchema),
  });

  return (
    <FormProvider {...methods}>
      <SunshineModal isOpen onClose={onClose}>
        <SunshineModal.Header />
        {children}
      </SunshineModal>
    </FormProvider>
  );
};

FiscalIdModal.Body = Body;
FiscalIdModal.Footer = Footer;

export default FiscalIdModal;
